import { multilingual_url } from '../utils/multilingual-url';
import '../../styles/components/cart-item.scss';

class CartItem extends HTMLElement {
  constructor() {
    super();

    this.editButton = this.querySelector('[data-edit]');
    this.editData = JSON.parse(this.querySelector('[data-edit-item-data]').innerHTML);

    if (this.editButton) {
      this.editButton.addEventListener('click', this.onEditButtonClick.bind(this));
    }
  }

  async onEditButtonClick() {
    const drawerEvent = new CustomEvent('open-product-drawer', {
      detail: {
        action: 'edit',
        product: {
          title: this.editData.title,
          handle: this.editData.handle,
          url: multilingual_url(`/products/${this.editData.handle}`),
        },
        selectedVariantId: this.editData.variantId,
        itemKey: this.editData.itemKey,
        itemQuantity: this.editData.itemQuantity
      }
    });

    document.dispatchEvent(drawerEvent);
  }
}

try {
  customElements.define('cart-item', CartItem);
}
catch(e) {}
